import {ServiceBase} from '../ServiceBase';
import {IArenasService} from './arenas.service.interface';
import {
    HOME_PAGE_ARENA,
    LIVE_CASINO_ARENA_NAME,
    NEW_LIVE_CASINO_AB_ARENA_NAME,
    NEW_LIVE_CASINO_ARENA_NAME
} from './arena-consts';
import {
    ArenaConfiguration
} from "../configurations/config-data-sections/arenas.configuration";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IArenaViewModel} from "./models/arenas/arena-view-model.interface";
import {HomePageArenaModel} from "./models/arenas/home-page/home-page-arena.model";
import {CasinoLobbyArenaModel} from "./models/arenas/casino-lobby/casino-lobby-arena.model";
import {VoidArenaModel} from "./models/arenas/void-arena/void-arena.model";
import {ListsSortOrderStorage} from "./models/lists-sort-order-storage";
import {NewLiveCasinoArenaModel} from "./models/arenas/new-live-casino/new-live-casino-arena.model";
import {LiveCasinoArenaModel} from "./models/arenas/live-casino/live-casino-arena.model";
import {NewLiveCasinoArenaAbModel} from "./models/arenas/new-live-casino-ab/new-live-casino-arena-ab.model";


export class ArenasService extends ServiceBase implements IArenasService {

    constructor(services: IServiceFactoryExtended) {
        super(services);
        this._postLoginListsSortOrderStorage = new ListsSortOrderStorage(services);
        this._loadArenas();
    }

    private _arenas: Record<string, IArenaViewModel> = {};
    private readonly _postLoginListsSortOrderStorage: ListsSortOrderStorage;

    private _loadArenas(): void {
        this._arenas[HOME_PAGE_ARENA] = this._createArena(HOME_PAGE_ARENA);
        const arenasConfigs = this.services.configuration.data.arenas;
        for(let arenaName in arenasConfigs) {
            this._arenas[arenaName] = this._createArena(arenaName);
        }
    }

    getArena(arenaName: string): IArenaViewModel {
        return this._arenas[arenaName] || new VoidArenaModel(this.services);
    }

    private _createArena(arenaName: string): IArenaViewModel | null {
        switch (arenaName) {
            case NEW_LIVE_CASINO_AB_ARENA_NAME:
                return new NewLiveCasinoArenaAbModel(arenaName, this.services, this._postLoginListsSortOrderStorage);
            case HOME_PAGE_ARENA:
                return new HomePageArenaModel(this.services, this._postLoginListsSortOrderStorage);
            case NEW_LIVE_CASINO_ARENA_NAME:
                return new NewLiveCasinoArenaModel(arenaName, this.services);
            case LIVE_CASINO_ARENA_NAME:
                return new LiveCasinoArenaModel(arenaName, this.services);
            default:
                return new CasinoLobbyArenaModel(arenaName, this.services, this._postLoginListsSortOrderStorage);
        }
    }

    getCurrentArena(): IArenaViewModel {
        const arenaName = this.services.routing.currentRoute.data?.arenaType;
        if(!arenaName) {
            return new VoidArenaModel(this.services);
        }
        return this.getArena(arenaName)

    }

    getArenaConfig(arenaType: string): ArenaConfiguration {
        return this.services.configuration.data.arenas[arenaType];
    }

    shouldHideFiltersButtonMobile(): boolean {
        const arenasWithoutFilterButton: string[] = [NEW_LIVE_CASINO_ARENA_NAME];
        const currentRoute = this.services.routing.currentRoute;
        return arenasWithoutFilterButton.includes(currentRoute?.data?.arenaType);
    }
}
